import Vue from 'vue'
import Router from 'vue-router'

import store from '@/store/index'
import Home from '@/pages/home/Home'
import Authority from '@/pages/authority/Authority'

Vue.use(Router)

// 懒加载方式，当路由被访问的时候才加载对应组件
const Login = resolve => require(['@/pages/Login'], resolve)

const router = new Router({
  routes: [{
    path: '/',
    name: 'login',
    component: Login
  }]
})

export const DynamicRoutes = [{
  path: '/home',
  component: Home,
  name: '路由管理',
  menuShow: true,
  leaf: true,
  iconCls: 'iconfont icon-luyoubiao',
  children: [{
    path: '/authority',
    component: Authority,
    name: '路由管理',
    menuShow: true
  }]
}]

router.beforeEach((to, from, next) => {
  console.log('beforeEach.....')

  if (to.path === '/') {
    console.log('退出登录')
    window.localStorage.removeItem('access-user')

    next()
  } else {
    let user = JSON.parse(window.localStorage.getItem('access-user'))
    if (!user) {
      next({
        path: '/'
      })
    } else {
      if (!store.state.permission.permissionList) {
        console.log('重新获取路由信息')
        store.dispatch('permission/FETCH_PERMISSION').then(() => {
          console.log(to.path)
          next({path: to.path})
        })
      }
      console.log(to.path)
      next()
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js